import { createContext } from "@singlestore/fusion/react-utils/context";

export type SiteContextType = {
    pathname: string;
};

export const [SiteProvider, useSiteContext] = createContext<SiteContextType>();
